export default __webpack_public_path__ + "static/media/V420_RoHS.30355e0f.pdf";